import { FC } from "react";
import { useTranslation } from "react-i18next";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { BookingDataType } from "data/interfaces";
import { daysUntilStart } from "application/utils/latestBooking";

interface Props {
  item: BookingDataType;
  onSendRequest: (item: BookingDataType) => void | Promise<void>;
  onRemove: (item: BookingDataType) => void;
  onChangeDates: (item: BookingDataType) => void;
  isLoading?: boolean;
}

const InRequestWindowPanel: FC<Props> = ({
  item,
  onSendRequest,
  onRemove,
  onChangeDates,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const days = daysUntilStart(item.startDate);

  return (
    <div className="mt-3 p-4 rounded-lg border border-amber-200 bg-amber-50">
      <div className="flex items-center gap-2 mb-2">
        <span className="inline-flex items-center gap-1.5 bg-amber-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
          <i className="las la-hourglass-half text-xs" aria-hidden="true" />
          {t("translation:detailPages.common.withinRequestWindowBadge")}
        </span>
        <span className="text-xs text-amber-800">
          {t("translation:detailPages.common.daysRemaining", { days })}
        </span>
      </div>

      <div className="flex flex-wrap gap-2">
        <ButtonPrimary
          onClick={() => onSendRequest(item)}
          loading={isLoading}
          className="!bg-amber-500 hover:!bg-amber-600"
        >
          {t("translation:detailPages.common.sendRequest")}
        </ButtonPrimary>

        <button
          type="button"
          onClick={() => onChangeDates(item)}
          className="inline-flex items-center justify-center px-4 py-2 rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 text-sm"
        >
          {t("translation:detailPages.common.changeDates")}
        </button>

        <button
          type="button"
          onClick={() => onRemove(item)}
          className="inline-flex items-center justify-center px-4 py-2 rounded-full text-sm text-red-600 hover:bg-red-50"
        >
          {t("translation:myTrip.removeFromTrip")}
        </button>
      </div>
    </div>
  );
};

export default InRequestWindowPanel;
